<template>
  <div class="tourists-quantity-group">
    <label><b>{{label}}</b></label>
    <div class="group-buttons">
      <RoundButton @click="on_minus">-</RoundButton>
      <RoundButton static>{{localValue}}</RoundButton>
      <RoundButton @click="on_plus">+</RoundButton>
    </div>
  </div>
</template>
<script>
  import RoundButton from "./RoundButton";
  export default {
    components:{RoundButton},
    props: ['value', 'label', 'min'],
    data(){
      return {
        localValue: this.value,
      }
    },
    methods:{
      on_minus(){
        if (this.localValue > this.min) {
          this.localValue -= 1;
          this.$emit('change', this.localValue);
        }
      },
      on_plus(){
        this.localValue += 1;
        this.$emit('change', this.localValue);
      },
    }

  }
</script>